/**
 * LeanIQ Friend referral lock
 * - FRIEND-* discount codes only allowed when cart has a subscription line
 * - Strips FRIEND codes if customer removes Subscribe / has OTP-only cart
 * - Quiet auto-strip (no toast) when Shop Now applies FRIEND before Subscribe
 * - Cart tip when a Travel Pack still has a price and FRIEND is not applied
 * - Does not affect THANKS-* advocate claim codes
 */
(function () {
  'use strict';

  var MSG =
    'This referral code only works with a subscription purchase. Add a Subscribe plan, then apply your code.';
  var CART_TIP =
    'Have a FRIEND referral code? Enter it in Discount below to unlock your free Travel Pack.';
  var enforcing = false;
  var tipSyncTimer = null;
  var tipObserver = null;

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function isFriendCode(code) {
    return /^FRIEND-/i.test(String(code || '').trim());
  }

  function hasQualifyingSubscription(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
    });
  }

  function friendCodesFromCart(cart) {
    var list = [];
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      var c = codes[i] && codes[i].code;
      if (c && isFriendCode(c)) list.push(c);
    }
    return list;
  }

  function otherCodesFromCart(cart) {
    var list = [];
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      var c = codes[i] && codes[i].code;
      if (c && !isFriendCode(c)) list.push(c);
    }
    return list;
  }

  async function fetchCart() {
    var res = await fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  async function setDiscountCodes(codes) {
    var res = await fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: (codes || []).join(',') })
    });
    if (!res.ok) throw new Error('cart discount update failed');
    return res.json();
  }

  /**
   * @param {string} code
   * @returns {Promise<boolean>} true if code may be applied
   */
  async function allowsFriendCode(code) {
    if (!isFriendCode(code)) return true;
    var cart = await fetchCart();
    return hasQualifyingSubscription(cart);
  }

  function notifyCart(data) {
    try {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { data: { source: 'leaniq-friend-sub-lock', cart: data } }
        })
      );
    } catch (e) {}
    try {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'leaniq-friend-sub-lock', cart: data } }
        })
      );
    } catch (e2) {}
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname || '');
  }

  function lineProp(item, key) {
    if (!item || !item.properties) return '';
    if (item.properties[key] != null) return String(item.properties[key]);
    /* Shopify may expose hidden props with or without a leading underscore */
    var bare = String(key || '').replace(/^_/, '');
    if (bare && item.properties[bare] != null) return String(item.properties[bare]);
    if (bare && item.properties['_' + bare] != null) return String(item.properties['_' + bare]);
    return '';
  }

  function isTravelPackLine(item) {
    if (!item) return false;
    if (lineProp(item, '_liq_referral_gift') === 'travel_pack') return true;
    if (lineProp(item, '_liq_sub_gift') === 'travel_pack') return true;
    return /travel\s*pack/i.test(String(item.variant_title || ''));
  }

  /** Referral Travel Pack line from our gift helper (not ordinary sub gift). */
  function hasReferralGiftLine(cart) {
    return (cart.items || []).some(function (item) {
      return lineProp(item, '_liq_referral_gift') === 'travel_pack';
    });
  }

  /** Any Travel Pack still charging the customer (FRIEND not applied / not discounted). */
  function hasPricedTravelPack(cart) {
    return (cart.items || []).some(function (item) {
      return isTravelPackLine(item) && Number(item.final_line_price || 0) > 0;
    });
  }

  function cartReferralAttr(cart) {
    if (!cart || !cart.attributes) return '';
    return String(cart.attributes._liq_referral_aic || cart.attributes.liq_referral_aic || '').trim();
  }

  function isReferralSession(cart) {
    if (hasReferralGiftLine(cart)) return true;
    if (cartReferralAttr(cart)) return true;
    try {
      if (window.LiqReferralGift && typeof window.LiqReferralGift.isAttributed === 'function') {
        if (window.LiqReferralGift.isAttributed()) return true;
      }
    } catch (e) {}
    try {
      var params = new URLSearchParams(window.location.search || '');
      if ((params.get('aic') || params.get('referrer_id') || '').trim()) return true;
    } catch (e2) {}
    return false;
  }

  function ensureCartTipStyles() {
    if (document.getElementById('liq-friend-cart-tip-style')) return;
    var style = document.createElement('style');
    style.id = 'liq-friend-cart-tip-style';
    style.textContent =
      '#liq-friend-cart-tip{display:block;width:100%;box-sizing:border-box;margin:12px 0 16px;padding:12px 14px;border-radius:8px;background:#F7EAF2;border:1px solid #E7C6DB;color:#1f1f1f;font:14px/1.45 system-ui,sans-serif;position:relative;z-index:2}' +
      '#liq-friend-cart-tip[hidden]{display:none!important}' +
      '#liq-friend-cart-tip strong{font-weight:700}';
    document.head.appendChild(style);
  }

  function hideCartTip() {
    var el = document.getElementById('liq-friend-cart-tip');
    if (el) el.hidden = true;
  }

  function mountCartTipEl() {
    ensureCartTipStyles();
    var el = document.getElementById('liq-friend-cart-tip');
    if (el && document.body.contains(el)) return el;
    el = document.createElement('div');
    el.id = 'liq-friend-cart-tip';
    el.setAttribute('role', 'status');
    el.innerHTML = '<strong>Referral tip:</strong> ' + CART_TIP;
    var title = document.querySelector('.cart-page__title');
    var page = document.querySelector('.cart-page');
    if (title && title.parentNode) {
      title.insertAdjacentElement('afterend', el);
    } else if (page) {
      page.insertAdjacentElement('afterbegin', el);
    } else {
      var comp = document.querySelector('cart-items-component');
      if (comp) comp.insertAdjacentElement('afterbegin', el);
      else document.body.insertAdjacentElement('afterbegin', el);
    }
    return el;
  }

  function showCartTip() {
    if (!isCartPage()) return;
    var el = mountCartTipEl();
    el.hidden = false;
  }

  /**
   * Tip only for referral carts: aic / referral gift / cart attr,
   * Subscribe present, any Travel Pack still priced, no FRIEND code.
   * Ordinary Subscribe carts (no referral) never show this.
   */
  function shouldShowCartTip(cart) {
    return !!(
      cart &&
      isReferralSession(cart) &&
      hasQualifyingSubscription(cart) &&
      hasPricedTravelPack(cart) &&
      !friendCodesFromCart(cart).length
    );
  }

  function syncCartTip(cart) {
    if (!isCartPage()) return;
    if (shouldShowCartTip(cart)) showCartTip();
    else hideCartTip();
  }

  async function refreshCartTip() {
    if (!isCartPage()) return;
    try {
      var cart = await fetchCart();
      syncCartTip(cart);
    } catch (err) {
      console.warn('[liq-friend-sub-lock] tip sync failed', err);
    }
  }

  function scheduleCartTipRefresh() {
    if (!isCartPage()) return;
    window.clearTimeout(tipSyncTimer);
    tipSyncTimer = window.setTimeout(function () {
      refreshCartTip();
    }, 100);
  }

  function ensureTipObserver() {
    if (!isCartPage() || tipObserver || typeof MutationObserver === 'undefined') return;
    var page = document.querySelector('.cart-page');
    if (!page) return;
    tipObserver = new MutationObserver(function () {
      var el = document.getElementById('liq-friend-cart-tip');
      if (!el || !document.body.contains(el) || el.hidden) {
        scheduleCartTipRefresh();
      }
    });
    tipObserver.observe(page, { childList: true, subtree: true });
  }

  /**
   * Remove FRIEND-* codes when cart has no subscription.
   * Auto-enforce is silent (no toast). Manual apply still shows cart field error.
   * @returns {Promise<{removed:boolean, cart?:object}>}
   */
  async function enforce(opts) {
    /* Tip sync is independent so cart morph / concurrent calls cannot skip it */
    scheduleCartTipRefresh();
    if (enforcing) return { removed: false };
    opts = opts || {};
    enforcing = true;
    try {
      var cart = await fetchCart();
      syncCartTip(cart);
      var friends = friendCodesFromCart(cart);
      if (!friends.length) return { removed: false, cart: cart };
      if (hasQualifyingSubscription(cart)) return { removed: false, cart: cart };

      var kept = otherCodesFromCart(cart);
      var updated = await setDiscountCodes(kept);
      /* Auto-strip is quiet; cart discount field still shows error on manual apply */
      notifyCart(updated);
      syncCartTip(updated);
      if (opts.reload) {
        window.setTimeout(function () {
          window.location.reload();
        }, 50);
      }
      return { removed: true, cart: updated };
    } catch (err) {
      console.warn('[liq-friend-sub-lock] enforce failed', err);
      return { removed: false, error: err };
    } finally {
      enforcing = false;
    }
  }

  window.LiqFriendSubLock = {
    isFriendCode: isFriendCode,
    allowsFriendCode: allowsFriendCode,
    enforce: enforce,
    refreshCartTip: refreshCartTip,
    message: MSG,
    cartTip: CART_TIP
  };

  function scheduleEnforce() {
    window.setTimeout(function () {
      enforce({ silent: true });
    }, 250);
  }

  function bootCartTip() {
    if (!isCartPage()) return;
    ensureTipObserver();
    [200, 600, 1200, 2000].forEach(function (ms) {
      window.setTimeout(function () {
        ensureTipObserver();
        refreshCartTip();
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleEnforce();
      bootCartTip();
    });
  } else {
    scheduleEnforce();
    bootCartTip();
  }

  document.addEventListener('cart:update', function (e) {
    var src = e && e.detail && e.detail.data && e.detail.data.source;
    if (src === 'leaniq-friend-sub-lock') return;
    scheduleEnforce();
    scheduleCartTipRefresh();
  });
  document.addEventListener('cart:refresh', function (e) {
    var src = e && e.detail && e.detail.data && e.detail.data.source;
    if (src === 'leaniq-friend-sub-lock') return;
    scheduleEnforce();
    scheduleCartTipRefresh();
  });
  document.addEventListener('shopify:section:load', scheduleCartTipRefresh);
  window.addEventListener('pageshow', bootCartTip);
})();

